import React, { Component } from 'react';
import './Grid.css';
import { DataphiGrid } from './DataphiGrid'
import { Modal } from 'react-bootstrap'
import CONSTANTS from '../../../../Phi/Constants'
import { toast } from 'react-toastify';

import Validator from 'dataphi-react-components/dist/Containers/FormScreen/FormComponent/Validator'

import 'react-datepicker/dist/react-datepicker.css'
import 'react-select/dist/react-select.css'
import Constants from '../../../../Phi/Constants';

const assessmentKeys = {
    'ENT': 3,
    'EYE': 4,
    'PHYSICAL': 5,
    'DENTAL': 6
}

const ailmentKeyAnaemia = [
    'General_signs_Cynosis',
    'Head_Abnormal_Hair_Pigmentation',
    'Skin_Pigmentation',
    'General_signs_Anemia'
]

const ailmentKeyLymph = [
    'Lymphatic_PLN_Cervical',
    'Lymphatic_PLN_Submandibular',
    'Lymphatic_PLN_Pre_Auricular',
    'Lymphatic_PLN_Submental'
]

const ailmentKeyTeeth = [
    'Chief_Complaint_Tooth_Pain',
    'Chief_Complaint_Bleeding_Gums',
    'Chief_Complaint_Decayed_Teeth',
    'Chief_Complaint_Inflamed_Gums'
]

const ailmentKeyChest = [
    'Cardiovascular_Murmur',
    'Cardiovascular_Abnormal_heart_sounds'
]

const ailmentKeyAbdoment = [
    'Abdomen_Distended',
    'Abdomen_Tense',
    'Abdomen_Tender',
    'Xray_Abdomen',
    'Ultrasound_Abdomen'
]

const eyeOptemetricArray = [
    '6/6',
    '6/9',
    '6/12',
    '6/18',
    '6/24',
    '6/36',
    '6/60' 
]

class HSGStudentGrid extends Component {
    constructor(props) {
        super(props)
        this.state = {
            studentList: null,
            studentTotal: 0,

            currentStudentInfo: null,
            currentEpisodeArray: null,
            fullAilmentViewBlock: null,

            toggleStudentGrowthModal: false,
            toggleStudentMedicalModal: false,
            toggleFullAilmentViewModal: false,
            toggleStudentEYEModal: false,

            collapsedUUID: null
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.studentList && nextProps.studentList.length && JSON.stringify(this.props.studentList) !== JSON.stringify(nextProps.studentList) || this.props.studentTotal !== nextProps.studentTotal) {
            this.setState({
                studentList: this.formatStudentData(nextProps.studentList),
                studentTotal: nextProps.studentTotal
            })
        }

        if (nextProps.studentList !== this.props.studentList) {
            this.setState({
                studentList: this.formatStudentData(nextProps.studentList),
                studentTotal: nextProps.studentTotal
            })
        }
    }

    updateStateForVariable = (stateVar, val) => {
        this.setState({stateVar: val})
    }

    formatStudentData = data => {
        if (!!!data) {
            return []
        } else {
            let genderMap = {
                "M": "MALE",
                "F": "FEMALE",
                "O": "OTHER"
            }
            let newData = data.map((d, i) => {

                let studentInfo = d.student_inf[0]
                let studentCustom = d.student_inf[0].json_value

                let episodes = d.student_episodes && d.student_episodes.length ? d.student_episodes[0] : null

                let studentGrowthEpisode = episodes && episodes.episode ? episodes.episode.filter((a) => a.type === 1) : {}
                let studentEyeEpisode = episodes && episodes.episode ? episodes.episode.filter((a) => a.type === 2) : {}

                let lattestEventId = d.mains && d.mains.length ? d.mains[0].lattestEventId : null
                let studentAssessment = d.mains

                let latestGrowthEpisode =  studentGrowthEpisode && studentGrowthEpisode.length ? studentGrowthEpisode[0].episode_custom_json : {}
                let latestEyeEpisode =  studentEyeEpisode && studentEyeEpisode.length ? studentEyeEpisode[0].episode_custom_json : {}

                let d_object = Object.assign({})
                
                d_object.fivePerc = episodes.five_perc
                d_object.eightyFivePerc = episodes.eightyfive_perc
                d_object.idealAtFive = episodes.ideal_at_five
                d_object.idealAtEightyFive = episodes.ideal_at_eighty_five
                d_object.trueBMI = episodes.true_bmi

                d_object.studentId = d.student_id

                d_object.uuid = studentInfo.uuid
                d_object.section = studentInfo.section
                d_object.class = studentInfo.class
                d_object.firstName = studentInfo.name
                d_object.dob = studentInfo.dob
                d_object.gender = genderMap[studentInfo.gender]
                d_object.admissionNumber = studentInfo.admission_number
                d_object.phoneNumber = studentInfo.user_phone_number
                d_object.email = studentInfo.user_email

                d_object.custom = studentCustom
                d_object.foodAllergies = studentCustom.foodAllergies
                d_object.medicineAllergies = studentCustom.medicineAllergies
                d_object.bloodGroup = studentCustom.bloodGroup
                d_object.parentName = studentCustom.parent_name
                d_object.authenticationCode = studentCustom.authentication_code

                d_object.lattestEventId = lattestEventId

                d_object.growthEpisodes = studentGrowthEpisode
                d_object.eyeEpisodes = studentEyeEpisode

                d_object.studentAssessment = studentAssessment

                d_object.latestBMI = episodes.new_bmi ? episodes.new_bmi.toUpperCase() + ` (${episodes.new_bmi_val})` : null
                d_object.latestHeight = latestGrowthEpisode.med_height
                d_object.latestWeight = latestGrowthEpisode.med_weight
                d_object.latestPulse = latestGrowthEpisode.med_heart_rate
                d_object.latestBPSYS = latestGrowthEpisode.med_bp_sys
                d_object.latestBPDIA = latestGrowthEpisode.med_bp_dia

                d_object.latestLeftEye = latestEyeEpisode.leftEye
                d_object.latestRightEye = latestEyeEpisode.rightEye

                return d_object
            })
            return newData
        }
    }

    searchStudent = (e) => {
        const {inSearchString} = this.state
        e.keyCode === 13 && this.props.search(inSearchString.trim().toLowerCase())
    }

    toolbar = props => {
        return (
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className='search-box-container'>
                    <input onChange={(e) => this.setState({inSearchString: e.target.value})} onKeyDown={e=>{this.searchStudent(e)}} placeholder="Type in student name or HSG-ID.." className="input-search-box" type='text' value={this.state.inSearchString} />
                </div>
            </div>
        );
    }

    onPageChange = (page, sizePerPage) => {
        console.log("page, sizePerPage: ", page, sizePerPage)
    }

    renderPaginationPanel = () => {

        return (
            <div>AAAA</div>
        )
    }

    sizePerPageListChange(sizePerPage) {
        let { parameters } = this.state
        parameters.length = sizePerPage
        this.props.fetchTableData(parameters)
    }

    renderSizePerPageDropDown = props => {
        return (
            <div className='btn-group'>
                {
                    [10, 25, 30].map((n, idx) => {
                        const isActive = (n === props.currSizePerPage) ? 'active' : null;
                        return (
                            <button
                                key={idx}
                                type='button'
                                className={`btn btn-info ${isActive}`}
                                //onClick={() => props.changeSizePerPage(n)}
                                onClick={(e) => this.changeSizePerPage(n, props, e)}
                            >
                                {n}
                            </button>
                        );
                    })
                }
            </div>
        );
    }

    onRowSelect = (row, isSelected, e) => {
        console.log("onRowSelect: ", row, isSelected, e)
    }

    editStudentDetail = (row) => {
        this.setState({
            showEditStudentModal: !this.state.showEditStudentModal,
            editableRow: {...row}
        })
    }

    openNewTab = (hsgId, type) => window.open(`/report/student/${this.props.startNodeId}/${type}/${hsgId}`, "_blank")

    getStyle = (width) => `hsg-edit-details${window.innerWidth < 1025 ? "-small" : ""}`

    getActions = (cell, row, unqIdentifier) => row.status >= CONSTANTS.qcCheckedStatusMap.PUBLISHED ? (
        <div className="center">
            <p className={this.getStyle(window.innerWidth)} onClick={() => this.openNewTab(row.uuid, 'growth')}>Growth</p>
            <p className={this.getStyle(window.innerWidth)} onClick={() => this.openNewTab(row.uuid, 'physical')}>Physical</p>
            <p className={this.getStyle(window.innerWidth)} onClick={() => this.openNewTab(row.uuid, 'ent')}>ENT</p>
            <p className={this.getStyle(window.innerWidth)} onClick={() => this.openNewTab(row.uuid, 'eye')}>Eye</p>
            <p className={this.getStyle(window.innerWidth)} onClick={() => this.openNewTab(row.uuid, 'dental')}>Dental</p>
        </div>
    ) : <p className="center">NA</p>

    getStudentName = (cell, row, unqIdentifier) => (
        <div>
            <p>
                {row.studentname} 
                {
                    row.gender === 'MALE' ? <image style={{marginLeft:5}} width = "20px" height = "20px" src = "img/maleImage.png"/> : 
                    <image style={{marginLeft:5}} width = "20px" height = "20px" src = "img/femaleImage.png"/>
                }
            </p>
        </div>
    )
    
    getStudentDetails = (cell, row, unqIdentifier) => (
        <div className="center">
            <p onClick={() => this.toggleStudentDetailModal(true, row)} style = {{cursor: "pointer"}}><span className={"glyphicon glyphicon-info-sign"}></span></p>
        </div>
    )

    toggleStudentDetailModal = (flag, student) => {
        
        this.setState({
            studentDetailModalView: flag,
            currentStudentInfo: student
        })

    }

    toggleFullAilmentViewModal = (flag,block) => {
        this.setState ({
            toggleFullAilmentViewModal: flag,
            fullAilmentViewBlock: block
        })
    }

    formatItemLabel = (item) => {

        let prefixLabel = item.prefix_label.split('_').join(' ').split('-').join('')
        let category = item.category.split('_').join(' ').split('-').join('').toUpperCase()
        let label =  item.label.toLowerCase().indexOf(prefixLabel.toLowerCase()) === 0 && (item.label.length > item.prefix_label.length) ? item.label.slice(prefixLabel.length, item.label.length).trim().toUpperCase() : item.label.toUpperCase()
        return !label.includes(category) && category.includes('EAR') ? category + ' ' + label : label  ///HOT FIX FOR LABLE GENERATION

      }

    getViewLessThenFive = (block) => {

        return (
            block ? block.map((data,i) => {
                if (data){
                    return (
                        <div key = {i}>
                            {this.formatItemLabel(data)}
                            <br/>
                        </div>
                    )
                }else {
                    return null
                }
            }): '-'
        )

    }

    getViewMoreThenFive = (block) => {

        let newBlock = block.slice(0,3)

        newBlock = [...newBlock, 'View All']

        return (
            newBlock ? newBlock.map((data,i) => {
                if (data){
                    return (
                        data !== 'View All' ?
                        <div key = {i}>
                            {this.formatItemLabel(data)}
                            <br/>
                        </div> : 
                        <div key = {i} onClick={()=>this.toggleFullAilmentViewModal(true,block)} style ={{color : "#34bfa3", cursor: "pointer"} }>
                            {data}
                        </div>
                    )
                }else {
                    return null
                }
            }): '-'
        )

    }

    getDataAilmentFromKeys = (ailment, key) => {

        let block = []
        ailment && key && block.push(key.map((k, i) => {
            let data = ailment.filter(a => a.key === k)
            if (data && data.length) {
                return data[0]
            }
        }))
        
        block = block && block.length && block[0].filter((a) => a !== null && a !== undefined)

        let view  = block.length < 1 ? '-' :  block.length > 3 ? this.getViewMoreThenFive(block) : this.getViewLessThenFive(block)

        return view
    }

    getDataAilmentFromActivity = (ailment, activity) => {

        let block = []
        let data = ailment && activity && ailment.filter(a => a.activity_id === activity)
        if (data && data.length) {
            block.push(
                data.map((d, i) => {
                    return d
                })
            )
        }

        block = block && block.length && block[0].filter((a) => a !== null && a !== undefined)

        let view  = block.length < 1 ? '-' : block.length > 3 ? this.getViewMoreThenFive(block) : this.getViewLessThenFive(block)


        return view

    }

    getTableHeader = () => {
        
        return [
            {
                value: 'DOE',
                dataField: 'DOE',
                width: '10',
            },
            {
                value: 'HEIGHT',
                dataField: 'height',
                width: '15'
            },
            {
                value: 'WEIGHT',
                dataField: 'weight',
                width: '15'
            },
            {
                value: 'BMI',
                dataField: 'bmi',
                width: '20'
            },
            {
                value: 'PULSE',
                dataField: 'pulse',
                width: '15'
            },
            {
                value: 'BP SYS',
                dataField: 'sys',
                width: '15'
            },
            {
                value: 'BP DIA',
                dataField: 'dia',
                width: '15'
            },
            {
                value: 'ANAEMIA',
                dataField: 'anemia',
                width: '30'
            },
            {
                value: 'LYMPH GLANDS',
                dataField: 'lymph',
                width: '30'
            },
            {
                value: 'EYES',
                dataField: 'eye',
                width: '30'
            },
            {
                value: 'ENT',
                dataField: 'ent',
                width: '30'
            },
            {
                value: 'TEETH & GUMS',
                dataField: 'teeth_gum',
                width: '30'
            },
            {
                value: 'CHEST',
                dataField: 'chest',
                width: '30'
            },
            {
                value: 'ABDOMEN',
                dataField: 'abdomen',
                width: '30'
            }
        ]
    }

    formatAilmentData = (mains) => {

        if (!!!mains) {
            return null
        } else {

            let newData = mains.map((data, i) => {
                if (data.event_track_id){

                    let metric = data.metric
                    let anthro = metric.anthro
                    let ailment = metric.ailment
                    let bmi = metric.bmi
                    let bmiVal = metric.bmi_val

                    let d_object = Object.assign({})

                    d_object.height = anthro.height || '-'
                    d_object.weight = anthro.weight  || '-'
                    d_object.pulse = anthro.pulse || '-'
                    d_object.sys = anthro.sys || '-'
                    d_object.dia = anthro.dia || '-'
                    d_object.bmi = bmi ? <div> <div>{bmi.toUpperCase()}</div> <br/> <div>{bmiVal}</div> </div> : '-'

                    d_object.DOE = metric.DOE ? new Date(metric.DOE).getFullYear() : '-'

                    d_object.anemia = this.getDataAilmentFromKeys(ailment, ailmentKeyAnaemia)
                    d_object.teeth = this.getDataAilmentFromKeys(ailment, ailmentKeyTeeth)
                    d_object.lymph = this.getDataAilmentFromKeys(ailment, ailmentKeyLymph)

                    d_object.eye = this.getDataAilmentFromActivity(ailment, 4)
                    d_object.ent = this.getDataAilmentFromActivity(ailment, 3)

                    d_object.teeth_gum = this.getDataAilmentFromKeys(ailment, ailmentKeyTeeth)
                    d_object.chest = this.getDataAilmentFromKeys(ailment, ailmentKeyChest)
                    d_object.abdomen = this.getDataAilmentFromKeys(ailment, ailmentKeyAbdoment)

                    return d_object
                }else {
                    return null
                }
            })
            return newData.filter((a) => a !== null && a !== undefined)
        }
    }

    getData = (data = [], offset) => {
        const rowData = data.reduce((newArr, dataElement, index)=>{
            const newDataElement = {
                ...dataElement,
                index: 1 + index,
            }
            newArr.push(newDataElement)
            return newArr
        }, [])
        return rowData
    }

    calculateDob = (dob) => {

        if(dob) {
            let birthday = new Date(dob)
            let ageDifMs = Date.now() - birthday.getTime();
            let ageDate = new Date(ageDifMs); // miliseconds from epoch
            
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        }
        return 'N/A'
    }

    toggleStudentEpisodeModal = (value, episodeArray) => {
        this.setState({
            toggleStudentEpisodeModal: value,
            currentEpisodeArray: episodeArray
        })
    }

    toggleStudentGrowthModal = (value, studentsInfo) => {
        this.setState({
            toggleStudentGrowthModal: value,
            currentStudentInfo: studentsInfo
        })
    }

    toggleStudentEYEModal = (value, studentsInfo) => {
        this.setState({
            toggleStudentEYEModal: value,
            currentStudentInfo: studentsInfo
        })
    }

    toggleStudentMedicalModal = (value, studentsInfo) => {
        this.setState({
            toggleStudentMedicalModal: value,
            currentStudentInfo: studentsInfo
        })
    }

    updateStudentGrowthInfo = (height, weight, pulse, bp_sys, bp_dia, student) => {

        if((height && weight && height >= 85 && height <= 215 && weight >= 10 && weight <= 200 ) && student){
            
            let studentId = student.studentId

            let custom = {
                med_height: height,
                med_weight: weight,
                med_heart_rate: pulse,
                med_bp_sys: bp_sys,
                med_bp_dia: bp_dia
            }

            let type = 1

            this.props.postStudentEpisodeInfo(studentId, custom, type)
            //this.props.fetchCustomStudentList()
            this.toggleStudentGrowthModal(false, null)
        }else {
            toast.warning("HEIGHT and WEIGHT should range between 85 cm to 215 cm and 10 kg to 200 kg respectively. And HEIGHT and WEIGHT is mendate.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true
            });
        }

    }

    updateStudentEYEInfo = (leftEye, rightEye, student) => {

        if(leftEye && rightEye && student){
            
            let studentId = student.studentId

            let custom = {
                leftEye: leftEye,
                rightEye: rightEye
            }

            let type = 2

            this.props.postStudentEpisodeInfo(studentId, custom, type)
            //this.props.fetchCustomStudentList()
            this.toggleStudentEYEModal(false, null)
        }else {
            toast.warning("All Fields are mandatory.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true
            });
        }


    }

    updateStudentMedicalInfo = (foodAllergies, medicineAllergies, bloodGroup, student) => {

        if((foodAllergies || medicineAllergies || bloodGroup) && student){
            
            let oldJson = student.custom

            let uuid = student.uuid

            let custom = {
                bloodGroup: bloodGroup,
                foodAllergies: foodAllergies,
                medicineAllergies: medicineAllergies,
                medInfoAddedTime: new Date(),
                medInfoAddedBy: this.props.userProfile.user_id
            }

            let newR = oldJson.merge(custom)

            this.props.addStudentMedicalInfo(uuid, newR)
            //this.props.fetchCustomStudentList()
            this.toggleStudentMedicalModal(false, null)
        }else {
            toast.warning("Atleast fill one of the Fields to submit.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                hideProgressBar: true
            });
        }

    }

    _renderFullAilmentViewModal = () => {

        const {fullAilmentViewBlock} = this.state

        let lastCategory = ''

        return (
            <div>
                <Modal show={this.state.toggleFullAilmentViewModal} onHide={()=>this.toggleFullAilmentViewModal(false, null)}>
                    <Modal.Header bsClass={'student-edit-modal-hd'}>
                        <Modal.Title>All Ailments</Modal.Title>
                    </Modal.Header>

                    <Modal.Body bsClass={'student-edit-modal-bd'}>
                    <div className="hsg-carebox-form">
                            {
                                fullAilmentViewBlock && fullAilmentViewBlock.map((ailment,index) => {
                                    return (
                                        <div key = {index}>
                                            <label className="hsg-sv-input hsg-margin-10">{this.formatItemLabel(ailment)}</label>                                                                                        
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="hsg-btn-white" onClick={()=>this.toggleFullAilmentViewModal(false, null)}>Close</button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    _renderStudentMedicalModal = () => {

        let foodAllergies = this.state.currentStudentInfo && this.state.currentStudentInfo.foodAllergies ? this.state.currentStudentInfo.foodAllergies : ''
        let medicineAllergies = this.state.currentStudentInfo && this.state.currentStudentInfo.medicineAllergies ? this.state.currentStudentInfo.medicineAllergies : ''
        let bloodGroup =  this.state.currentStudentInfo && this.state.currentStudentInfo.bloodGroup ? this.state.currentStudentInfo.bloodGroup : ''

        return (
            
            <div>
                <Modal show={this.state.toggleStudentMedicalModal} onHide={() => this.toggleStudentMedicalModal(false, null)}>
                    <Modal.Header >
                        <Modal.Title>Student Medical</Modal.Title>
                    </Modal.Header>

                    <Modal.Body >
                        <div className="hsg-carebox-form">

                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">FOOD ALLERGIES :</label>
                                <input className="hsg-input hsg-modal-block-input" defaultValue={foodAllergies} onChange={(e) => foodAllergies = e.target.value} autoFocus/>
                            </div>
                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">MEDICINE ALLERGIES :</label>
                                <input className="hsg-input hsg-modal-block-input" defaultValue={medicineAllergies} onChange={(e) => medicineAllergies = e.target.value} autoFocus/>
                            </div>
                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">BLOOD GROUP :</label>
                                <select className="hsg-input hsg-modal-block-input" defaultValue={bloodGroup ? bloodGroup : 'Not Selected'} onChange={(e) => bloodGroup = e.target.value} autoFocus>
                                    <option value = {''}>Not Selected</option>
                                    <option value = {'A+'}>A+</option>
                                    <option value = {'A-'}>A-</option>
                                    <option value = {'B+'}>B+</option>
                                    <option value = {'B-'}>B-</option>
                                    <option value = {'O+'}>O+</option>
                                    <option value = {'O-'}>O-</option>
                                    <option value = {'AB+'}>AB+</option>
                                    <option value = {'AB-'}>AB-</option>
                                </select>
                            </div>
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="hsg-btn-white" onClick={() => this.toggleStudentMedicalModal(false, null)}>Close</button>
                        <button className="hsg-btn" onClick={() => this.updateStudentMedicalInfo(foodAllergies ,medicineAllergies, bloodGroup, this.state.currentStudentInfo)}>Save</button>
                    </Modal.Footer>
                </Modal>
            </div>
            
        )

    }

    _renderStudentEpisodeModal = () => {

        let {currentEpisodeArray} = this.state

        let view = currentEpisodeArray && currentEpisodeArray.length ? currentEpisodeArray.map((data, index) => {
            return (
                <div key = {index}>
                    {
                        data.type === 2 ? 
                        <div>
                            <label className = "hsg-sv-label" style = {{marginLeft : 15, marginTop: 10}}>{'LEFT EYE: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.leftEye}</label>    

                            <label className = "hsg-sv-label" style = {{marginLeft : 10}}>{'RGIHT EYE: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.rightEye}</label>  

                            <br/>

                            <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'ADDED ON: '}</label>
                            <label className = "hsg-sv-input">{new Date(data.time) && new Date(data.time).toDateString()}</label>       

                            <br/>
                            <div className = "very-straight-line"/>
                        </div> :
                        <div>
                            <label className = "hsg-sv-label" style = {{marginLeft : 15, marginTop: 10}}>{'HEIGHT: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.med_height}</label>    

                            <label className = "hsg-sv-label" style = {{marginLeft : 10}}>{'WEIGHT: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.med_weight}</label>  
                        
                            <br/>

                            <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'PULSE: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.med_heart_rate}</label>    

                            <label className = "hsg-sv-label" style = {{marginLeft : 10}}>{'BP SYS: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.med_bp_sys}</label> 

                            <label className = "hsg-sv-label" style = {{marginLeft : 10}}>{'BP DIA: '}</label>
                            <label className = "hsg-sv-input">{data.episode_custom_json.med_bp_dia}</label> 
                            
                            <br/>

                            <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'ADDED ON: '}</label>
                            <label className = "hsg-sv-input">{new Date(data.time) && new Date(data.time).toDateString()}</label>       

                            <br/>
                            <div className = "very-straight-line"/>
                        </div>
                    }
                </div>
            )
        }) : <label className = "hsg-sv-label" style = {{marginLeft : 45, marginTop: 30}}>{'OOPS! NO DATA ADDED FOR THIS CHILD.'}</label>

        return (
            <Modal show={this.state.toggleStudentEpisodeModal} onHide={() => this.toggleStudentEpisodeModal(false, null)}>
                <Modal.Header >
                    <Modal.Title>HISTORY</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <div className="hsg-carebox-form">
                        {view}                   
                    </div>
                </Modal.Body>

                <Modal.Footer >
                    <button className="hsg-btn-white" onClick={() => this.toggleStudentEpisodeModal(false, null)}>Close</button>
                </Modal.Footer>
            </Modal>            
        )

    }

    
    _renderStudentDetailModal = () => {

        let {currentStudentInfo} = this.state

        return (
            <Modal show={this.state.studentDetailModalView} onHide={()=>this.toggleStudentDetailModal(false, null)}>
                <Modal.Header>
                    <Modal.Title>Student Information</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="hsg-carebox-form">

                        {
                            currentStudentInfo && currentStudentInfo.custom &&
                            <div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">NAME :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.firstName}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">CLASS :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.class}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">SECTION :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.section}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">GENDER :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.gender}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">DOB :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.dob}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">HSGID :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.uuid}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">ACTIVATION CODE :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.custom.activationCode}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">PARENT NAME :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.parentName}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">EMAIL ID :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.email}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">PHONE NUMBER :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.phoneNumber}/>
                                </div>
                                <div className = "hsg-margin-10">
                                    <label className="hsg-carebox-form-label hsg-modal-block-lable">ADMISSION NUMBER :</label>
                                    <input className="hsg-input hsg-modal-block-input" disabled defaultValue={currentStudentInfo.admissionNumber}/>
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button className="hsg-btn" onClick={()=>this.toggleStudentDetailModal(false, null)}>Close</button>
                </Modal.Footer>
            </Modal>
        )
    }

    _renderStudentGrowthModal = () => {

        let height, weight, pulse, bp_sys, bp_dia 

        return (
            <Modal show={this.state.toggleStudentGrowthModal} onHide={() => this.toggleStudentGrowthModal(false, null)}>
                <Modal.Header >
                    <Modal.Title>Student Growth</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <div className="hsg-carebox-form" id = "Modal">
                        <div>
                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">HEIGHT (CM) :</label>
                                <input className="hsg-input hsg-modal-block-input" type = "number" defaultValue={""} onChange={(e) => height = e.target.value} autoFocus/>
                            </div>

                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">WEIGHT (KG) :</label>
                                <input className="hsg-input hsg-modal-block-input" type = "number" defaultValue={""} onChange={(e) => weight = e.target.value}/>
                            </div>

                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">PULSE :</label>
                                <input className="hsg-input hsg-modal-block-input" type = "number" defaultValue={""} onChange={(e) => pulse = e.target.value}/>
                            </div>

                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">BP SYS :</label>
                                <input className="hsg-input hsg-modal-block-input" type = "number" defaultValue={""} onChange={(e) => bp_sys = e.target.value}/>
                            </div>

                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">BP DIA :</label>
                                <input className="hsg-input hsg-modal-block-input" type = "number" defaultValue={""} onChange={(e) => bp_dia = e.target.value}/>
                            </div>      
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer >
                    <button className="hsg-btn-white" onClick={() => this.toggleStudentGrowthModal(false, null)}>Close</button>
                    <button className="hsg-btn" onClick={() => this.updateStudentGrowthInfo(height, weight, pulse, bp_sys, bp_dia, this.state.currentStudentInfo)}>Save</button>
                </Modal.Footer>
            </Modal>            
        )

    }

    _renderStudentEYEModal = () => {

        let leftEye, rightEye

        return (
            <Modal show={this.state.toggleStudentEYEModal} onHide={() => this.toggleStudentEYEModal(false, null)}>
                <Modal.Header >
                    <Modal.Title>Student Vision</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="hsg-carebox-form">
                        <div >
                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">LEFT EYE :</label>
                                <select className="hsg-input hsg-modal-block-input" label="..." onChange={(e) => leftEye = e.target.value} autoFocus> 
                                    <option value={''}>Not Select</option>
                                    <option value={'6/6'}>6/6</option>
                                    <option value={'6/9'}>6/9</option>
                                    <option value={'6/12'}>6/12</option>
                                    <option value={'6/18'}>6/18</option>
                                    <option value={'6/24'}>6/24</option>
                                    <option value={'6/36'}>6/36</option>
                                    <option value={'6/60'}>6/60</option>
                                </select>
                            </div>
                            <div className = "hsg-margin-10">
                                <label className="hsg-carebox-form-label hsg-modal-block-lable">RIGHT EYE :</label>
                                <select className="hsg-input hsg-modal-block-input" label="..." onChange={(e) => rightEye = e.target.value} autoFocus> 
                                    <option value={''}>Not Select</option>
                                    <option value={'6/6'}>6/6</option>
                                    <option value={'6/9'}>6/9</option>
                                    <option value={'6/12'}>6/12</option>
                                    <option value={'6/18'}>6/18</option>
                                    <option value={'6/24'}>6/24</option>
                                    <option value={'6/36'}>6/36</option>
                                    <option value={'6/60'}>6/60</option>
                                </select>                            
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button className="hsg-btn-white" onClick={() => this.toggleStudentEYEModal(false, null)}>Close</button>
                    <button className="hsg-btn" onClick={() => this.updateStudentEYEInfo(leftEye, rightEye, this.state.currentStudentInfo)}>Save</button>
                </Modal.Footer>
            </Modal>            
        )

    }

    _renderStudentImpInfo = (student) => {

        const bmiMSG = `Healthy BMI range should be between ${student.fivePerc} to ${student.eightyFivePerc}. Need to ${student.trueBMI > student.eightyFivePerc ? 'lose' : 'gain'} ${student.trueBMI > student.eightyFivePerc ? student.idealAtEightyFive > 0 ? student.idealAtEightyFive : - student.idealAtEightyFive : student.idealAtFive > 0 ? student.idealAtFive : - student.idealAtFive } KG(s)`

        return( 
            <div> 
                <div className="col-md-12 col-sm-12 col-xs-12 student-assessment-block div-on-center">

                        {/** VITALS AND ANTHRO */}
                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'HEIGHT: '}</label>
                        <label className = "hsg-sv-input">{student.latestHeight ? student.latestHeight : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'WEIGHT: '}</label>
                        <label className = "hsg-sv-input">{student.latestWeight ? student.latestWeight : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'BMI: '}</label>
                        <label className = "hsg-sv-input">{student.latestBMI ? student.latestBMI : 'NA'}</label>

                        {
                            /**
                                <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'PULSE: '}</label>
                                <label className = "hsg-sv-input">{student.latestPulse ? student.latestPulse : 'NA'}</label>

                                <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'BP SYS: '}</label>
                                <label className = "hsg-sv-input">{student.latestBPSYS ? student.latestBPSYS : 'NA'}</label>

                                <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'BP DIA: '}</label>
                                <label className = "hsg-sv-input">{student.latestBPDIA ? student.latestBPDIA : 'NA'}</label>

                             */
                        }

                        <label className = "hsg-sv-label" style = {{marginLeft : 15, color : "#34bfa3", cursor: "pointer", marginRight : 5}} onClick = {() =>this.toggleStudentEpisodeModal(true, student.growthEpisodes)}>{'HISTORY'}</label>
                        {Constants.userPermissionMap[this.props.userRole].includes(Constants.userPermissionId.EDIT) &&
                            <label>
                                <label>|</label>
                                <label className = "hsg-sv-label" style = {{color : "#34bfa3", marginLeft : 5, cursor: "pointer"}} onClick = {() => this.toggleStudentGrowthModal(true, student)}>{'ADD INFO'}</label>
                            </label>
                        }

                        {/** EYE */}

                        <label className = "hsg-sv-label" style = {{marginLeft : 40}}>{'LEFT EYE: '}</label>
                        <label className = "hsg-sv-input">{student.latestLeftEye ? student.latestLeftEye : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'RIGHT EYE: '}</label>
                        <label className = "hsg-sv-input">{student.latestRightEye ? student.latestRightEye : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15, color : "#34bfa3", cursor: "pointer", marginRight : 5}} onClick = {() =>this.toggleStudentEpisodeModal(true, student.eyeEpisodes)}>{'HISTORY'}</label>
                        {Constants.userPermissionMap[this.props.userRole].includes(Constants.userPermissionId.EDIT) &&
                            <label>
                                <label>|</label>
                                <label className = "hsg-sv-label" style = {{color : "#34bfa3", marginLeft : 5, cursor: "pointer"}} onClick = {() => this.toggleStudentEYEModal(true, student)}>{'ADD INFO'}</label>
                            </label>
                        }
                        {/** PERSONAL */}

                        <label className = "hsg-sv-label" style = {{marginLeft : 40}}>{'BLOOD GROUP: '}</label>
                        <label className = "hsg-sv-input">{student.bloodGroup ? student.custom.bloodGroup : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'FOOD ALLERGIES: '}</label>
                        <label className = "hsg-sv-input">{student.custom.foodAllergies ? student.custom.foodAllergies : 'NA'}</label>

                        <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'MEDICINE ALLERGIES: '}</label>
                        <label className = "hsg-sv-input">{student.custom.medicineAllergies ? student.custom.medicineAllergies : 'NA'}</label>

                        {Constants.userPermissionMap[this.props.userRole].includes(Constants.userPermissionId.EDIT) &&
                            <label className = "hsg-sv-label" style = {{color : "#34bfa3", marginLeft : 15, cursor: "pointer"}} onClick = {() => this.toggleStudentMedicalModal(true, student)}>{student.custom.bloodGroup || student.custom.studentAllergies ? 'EDIT INFO':'ADD INFO'}</label>
                        }
                </div>
                {
                    (student.trueBMI > student.eightyFivePerc || student.trueBMI < student.fivePerc) &&
                    <div className="col-md-12 col-sm-12 col-xs-12 student-assessment-block div-on-center">
                        <label className = "hsg-sv-input"> {bmiMSG} </label>
                    </div>
                }
            </div>  
        )

    }
   
    _renderStudentBasicInfo = (student) => {

        let studentClass = student.class ? (student.class + (student.section ? ' | ' + student.section : '')) : 'NA'

        return (
            <div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <label className = "hsg-sv-input">{student.firstName ? student.firstName : 'NA'}</label>
                </div>                 
                <div className="col-md-6 col-sm-6 col-xs-6 div-on-right">
                    <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'CLASS: '}</label>
                    <label className = "hsg-sv-input">{`${studentClass}`}</label>

                    <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'HSGID: '}</label>
                    <label className = "hsg-sv-input">{student.uuid ? student.uuid : 'NA'}</label>

                    <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'ADMISSION NUMBER: '}</label>
                    <label className = "hsg-sv-input">{student.admissionNumber ? student.admissionNumber : 'NA'}</label>

                    <label className = "hsg-sv-label" style = {{marginLeft : 15}}>{'DOB: '}</label>
                    <label className = "hsg-sv-input">{student.dob ? student.dob : 'NA'}</label>

                    <label className = "hsg-sv-label"  style = {{color : "#34bfa3", marginLeft : 15, cursor: "pointer"}} onClick = {() => this.toggleStudentDetailModal(true, student)}>{'MORE INFO'}</label>
                </div>
            </div>
        )
    }

    _renderStudentDataGrid = (metric, uuid) => {

        let metricLen = metric.length

        if (uuid !== this.state.collapsedUUID) {
            metric = [metric[0]]
        }

        return (
            <div>
                
                <DataphiGrid
                    bordered={true}
                    trClassName={'trClassName'}
                    //selectRow={this.props.selectRowProp}
                    data={this.getData(metric ? metric : [])}
                    keyField={'index'}
                    tableHeaderColumn={this.getTableHeader()}
                    bordered
                    remote={true}
                    tableHeaderClass='my-header-class'
                    tableBodyClass='my-body-class'
                    containerClass='my-container-class'
                    tableContainerClass='hsg-table-individual-report'
                    headerContainerClass='my-header-container-class'
                    bodyContainerClass='my-body-container-class'
                />

                {
                    metricLen > 1 &&
                    <div className = "hsg-arrow-up-down">
                        {
                            this.state.collapsedUUID !== uuid ?
                            <span className = "glyphicon glyphicon-menu-down" onClick = {() => {this.setState({collapsedUUID: uuid})}}/> :
                            <span className = "glyphicon glyphicon-menu-up" onClick = {() => {this.setState({collapsedUUID: null})}}/>
                        }
                    </div>
                }
            </div>
        )

    }

    _renderNoDataAvail = (msg) => {
        return (
            <div className="hsg-msp-detail-empty">
                    { msg ? msg : "No Data Available"}
            </div>
        )
    }

    _renderStudentAilmentInfo = (mains, uuid) => {

        mains = mains.length > 1 ? mains.asMutable().sort((a,b) => {
            return b.event_track_id - a.event_track_id
        }) : mains
        
        let metric = this.formatAilmentData(mains) 
        
        return(
            <div>
                { metric && metric.length ? this._renderStudentDataGrid(metric, uuid) :  this._renderNoDataAvail('Student was not present during the assessment.') }
            </div>
        )

    }

    _renderStudentList = () => {

        const { studentList } = this.state

        return (
            <div>
                {
                    studentList && studentList.length ? studentList.map((student, index)=>{
                        return(
                            <div className = "container col-xs-12" key = {index} style = {{display: "inline", position : "relative"}}>
                                <div className="col-md-12 col-sm-12 col-xs-12 hsg-card">        
                                    
                                    <div className="col-md-12 col-sm-12 col-xs-12">  
                                        {
                                            this._renderStudentBasicInfo(student)
                                        }
                                    </div>
                                    <div className="col-md-12 col-sm-12 col-xs-12 hsg-margin-10">        
                                        {
                                            this._renderStudentImpInfo(student)
                                        }
                                    </div>       
                                    <div className="col-md-12 col-sm-12 col-xs-12">        
                                        {
                                            this._renderStudentAilmentInfo(student.studentAssessment, student.uuid)
                                        }
                                    </div>
                                </div>
                            </div>
                        )
                    }) : this._renderNoDataAvail('OOPS! Data is not available.')
                }
            </div>
        )

    }

    render() {

        return (
            <div>
                {this._renderStudentList()}                

                {this._renderStudentGrowthModal()}
                {this._renderStudentMedicalModal()}
                {this._renderFullAilmentViewModal()}
                {this._renderStudentEYEModal()}
                {this._renderStudentEpisodeModal()}
                {this._renderStudentDetailModal()}
            </div>
        )

    }
}

export default HSGStudentGrid


// WEBPACK FOOTER //
// ./src/Containers/StudentCustomContainer/Component/HSGStudentGrid/HSGStudentGrid.js